import styled from "styled-components";
import { palette } from "../../styles/constants";
import { cn } from "../../util/css";
import Icon from "../Icons";

type MerchantLogoProps = {
    src?: string;
    alt: string;
    size?: "sm" | "md";
    style?: React.CSSProperties & {
        "--placeholder-color"?: string;
        "--placeholder-bg"?: string;
    };
};

export default function MerchantLogo({
    src,
    alt,
    style,
    size = "sm",
}: MerchantLogoProps) {
    return (
        <Wrapper
            className={cn(
                !src && "placeholder",
                size === "sm" && "small",
                size === "md" && "medium",
            )}
            style={style}
        >
            {src ? (
                <Img src={src} alt={alt} />
            ) : (
                <Icon
                    icon="account"
                    size={size === "md" ? "xlarge" : "medium"}
                />
            )}
        </Wrapper>
    );
}

const Wrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    &.placeholder {
        background: var(--placeholder-bg, ${palette.darkmode[200]});
        color: var(--placeholder-color, ${palette.neutral[400]});
    }
    &.small {
        width: 32px;
        height: 32px;
        border-radius: 8px;
    }
    &.medium {
        width: 48px;
        height: 48px;
        border-radius: 12px;
    }
`;

const Img = styled.img`
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
`;
